import { map } from 'rxjs/operators/map';
import fetchJson$ from '../../common/fetch/as-json-stream';
import { AccessRequestCapabilityType } from '../confluence/access-request-capabilities/types';

const INLINE_JOIN_URL = '/gateway/api/invitations/v1/access-requests/request';

type InlineJoinResponse = {
	results: {
		[key: string]: AccessRequestCapabilityType;
	};
};

export const NO_ACCESS_ERROR_MESSAGE = 'No confluence access';

export const inlineJoin$ = (product: string, cloudId: string) =>
	fetchJson$<InlineJoinResponse>(INLINE_JOIN_URL, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			resource: `ari:cloud:${product}::site/${cloudId}`,
		}),
	}).pipe(
		map((response) => {
			const results = response.results;
			const result = results[`ari:cloud:${product}::site/${cloudId}`];
			if (
				result === AccessRequestCapabilityType.ACCESS_GRANTED ||
				result === AccessRequestCapabilityType.ACCESS_EXISTS ||
				result === AccessRequestCapabilityType.PENDING_REQUEST_CREATED
			) {
				return { status: true, result };
			}
			throw new Error(NO_ACCESS_ERROR_MESSAGE);
		}),
	);
